import { render, staticRenderFns } from "./DocTemplates.vue?vue&type=template&id=058c6266&scoped=true&"
import script from "./DocTemplates.vue?vue&type=script&lang=js&"
export * from "./DocTemplates.vue?vue&type=script&lang=js&"
import style0 from "./DocTemplates.vue?vue&type=style&index=0&id=058c6266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058c6266",
  null
  
)

component.options.__file = "DocTemplates.vue"
export default component.exports